const fr = {
  login: {
    title: 'Connexion',
  },
  actions: {
    view: 'Voir',
    add: 'Ajouter',
    edit: 'Modifier',
    cancel: 'Annuler',
    submit: 'Soumettre',
    update: 'Mettre à jour',
    save: 'Sauvegarder',
    back: 'Retour',
    delete: 'Supprimer',
    export: 'Exporter',
    exportAll: 'Tout exporter',
    download: 'Télécharger',
    generate: 'Générer',
    clear: 'Effacer',
    selectAll: 'Tout sélectionner',
    unselectAll: 'Tout déselectionner',
    preparingFile: 'Préparation du fichier...',
    continue: 'Continuer',
    newarticle: 'Nouvel article',
    addSPF: 'Ajouter le PF suggéré',
  },
  form: {
    fieldRequired: 'Ce champ est requis.',
    error: 'Erreur de serveur',

  },
  label: {
    type: 'Type',
    name: 'Nom',
    asset: 'Actif',
    liability: 'Passif',
    expense: 'Dépense',
    income: 'Revenu',
    none: 'Aucun',
    noneF: 'Aucune',
    companyName: 'Nom de la société',
    address: 'Adresse',
    email: 'Courriel',
    phone: 'Numéro de téléphone',
    rating: 'Notations',
    comments: 'Commentaires',
  },
  user: {
    language: 'Langue',
    firstName: 'Prénom',
    lastName: 'Nom',
    name: 'Nom',
    email: 'Courriel',
    phone: 'Téléphone',
    password: 'Mot de passe',
    confirm: 'Confirmer le mot de passe',
    type: 'Type',
    address: 'Adresse',
    member: 'Membre',
    role: 'Rôle',
    typeOptions: {
      standard: 'Copropriétaire',
      manager: 'Gestionnaire',
      administrator: 'Administrateur',
      superAdministrator: 'Super Administrateur',
      super: 'Super Administrateur',
      boardmember: 'Membre du Conseil',
    },
    deleteConfirmation: 'Cette action est irréversible. Êtes-vous certain de vouloir supprimer cet utilisateur?',
    userProfile: "Télécharger l'image",
    uploadDoc: 'Télécharger le document',
  },
  date: {
    From: 'Du',
    from: 'du',
    To: 'Au',
    to: 'au',
  },
  accountType: {
    income: 'Revenu',
    revenu: 'Revenu',
    assurance: 'Fond Auto Assurance',
    providence: 'Fond de prévoyance',
    depenses: 'Dépenses',
    expense: 'Dépense',
    expenses: 'Dépenses',
    profit: 'Profit',
    providentFund: 'Fond de prévoyance',
    providentFundShort: 'FP',
    fondAutoAssurance: 'Fond Auto Assurance',
    fondAutoAssuranceshort: 'FAA',
    notVisible: 'Non visible',
    notVisibleShort: 'NV',
    assets: 'Actifs',
    actifs: 'Actifs',
    passifs: 'Passifs',
    liabilities: 'Passifs',
    total: 'Total',
  },
  month: {
    january: 'Janvier',
    febuary: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Août',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Décembre',
    1: 'Janvier',
    2: 'Février',
    3: 'Mars',
    4: 'Avril',
    5: 'Mai',
    6: 'Juin',
    7: 'Juillet',
    8: 'Août',
    9: 'Septembre',
    10: 'Octobre',
    11: 'Novembre',
    12: 'Décembre',
  },
  coowner: {
    user: 'Utilisateur',
    user2: 'Utilisateur 2',
    address: 'Adresse',
    unit: 'Unité',
    insurance: 'Assurance',
    antitheft: 'Anti-vol',
    share: 'Quote-part',
    animal: 'Animaux',
    drd: 'DRD',
    institution: 'Institution',
    charge: 'Charge',
    account: 'Compte',
    parking: 'Stationnement',
    parkingAdditional: 'Stationnement additionnel',
    shed: 'Remise',
    car: 'Voiture',
    carAdditional: 'Voiture additionnelle',
    tenant: 'Locataire',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    notes: 'Notes',
  },
  syndicate: {
    type: 'Type',
    clientNumber: 'Numéro de client',
    name: 'Nom',
    shortName: 'Nom abrégé',
    address: 'Adresse',
    streetNumber: 'Numéro d’immeuble',
    streetName: 'Nom de rue',
    creationDate: 'Date de création',
    organizationNumber: 'Numéro d\'organisme',
    organizationName: 'Nom organisme',
    account: 'Compte',
    institution: 'Centrale informatique',
    institutionNumber: 'Numéro d’institution',
    field: 'Champ',
    insurance: 'Assurance',
    aga: 'AGA',
    pga: 'PGA',
    rules: 'Règlements',
    declaration: 'Déclaration',
    req: 'REQ',
    agaDate: 'Date de l\'AGA',
    acaDate: 'Date de l\'ACA',
    representative: 'Représentant horizontal',
    manager: 'Gestionnaire',
    admin: 'Administrateur',
    commonCharge: 'Charge commune',
    hasTaxes: 'Taxes',
    email: 'Courriel',
    reportFrequency: 'Fréquence des rapports',
    dayOfMonth: 'Jour du mois',
    boardMember: 'Membres du conseil d\'administration',
  },
  reportFrequency: {
    monthly: 'Mensuel',
    bimonthly: 'Bimensuel',
    quaterly: 'Trimestriel',
    fourMonthly: 'Quadrimestriel',
    semester: 'Semestriel',
    annually: 'Annuel',
  },
  transaction: {
    name: 'Nom',
    category: 'Poste',
    note: 'Note',
    selection: 'Sélection: ',
    transactionsCopied: 'transactions copiés',
  },
  notFound: {
    user: 'Utilisateur introuvable',
  },
};

export default fr;



// WEBPACK FOOTER //
// ./src/i18n/fr.js